export const pinSuccessStorageKey = 'pinSuccess'
